import "./App.css";
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Routes,
} from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaTruckFast } from "react-icons/fa6";
import { BiSolidNetworkChart } from "react-icons/bi";
import { FaRegUser } from "react-icons/fa";
import { GrGroup } from "react-icons/gr";
import { TbVersions } from "react-icons/tb";
import { FaChartBar } from "react-icons/fa";

//import { Link } from "react-router-dom";
// Equivalent to - function App() {
const App = () => {
  const [showNav, setShowNav] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [username, setUsername] = useState("");

  useEffect(() => {
    const el = document.getElementById("username");
    if (el) {
      setUsername(el.value);
    }
  }, []);

  return (
    <>
      <Router>
        <div>
          <GiHamburgerMenu
            className="menu"
            onClick={() => setShowNav(!showNav)}
          />
          <img
            className="logo"
            src="/static/images/Matadi2.png"
            alt="Matadi"
            onClick={() => setShowProfile(!showProfile)}
          />
        </div>
        {showNav && (
          <div>
            <ul className="leftnav">
              <li id="menu">
                <a href="/scp_v2/upload_csv_v2/">
                  <span role="img" aria-label="App3" title="App3">
                    Distribution Cost Optimization
                  </span>{" "}
                  &nbsp;
                  <BiSolidNetworkChart />
                </a>
              </li>

              <li id="menu">
                <a href="/upload/upload_csv_v3/">
                  <span role="img" aria-label="App3" title="App3">
                    Transshipment Optimization
                  </span>{" "}
                  &nbsp;
                  <FaTruckFast />
                </a>
              </li>
              <li id="menu">
                <a href="/charts/chart/">
                  <span role="img" aria-label="App3" title="App3">
                    Analytics
                  </span>{" "}
                  &nbsp;
                  <FaChartBar />
                </a>
              </li>
            </ul>
          </div>
        )}
        {showProfile && (
          <div>
            <ul className="profile">
              <li id="profilemenu">
                <FaRegUser />
                &nbsp;User: {username}
              </li>
              <li id="profilemenu">
                <GrGroup />
                &nbsp;Role: Public
              </li>
              <li id="profilemenu">
                <TbVersions />
                &nbsp;Version: 2025-01.001
              </li>
            </ul>
          </div>
        )}
      </Router>
    </>
  );
}

export default App;
